/**
 * LinkedData — renders the correlated Orees context (POS receipt, shift/staff, warehouse…)
 * sewn onto the anomaly. This IS the product thesis: video gives fact+time, Orees gives money,
 * orders, product movement, who was on shift (CLAUDE.md core thesis).
 */
import { LINKED_LABELS } from "@/lib/anomaly";

function renderValue(v: unknown): string {
  if (v === null || v === undefined) return "—";
  if (typeof v === "boolean") return v ? "да" : "нет";
  if (typeof v === "number") return new Intl.NumberFormat("ru-RU").format(v);
  if (typeof v === "string") return v;
  return JSON.stringify(v);
}

export function LinkedData({ data }: { data: Record<string, unknown> }) {
  const entries = Object.entries(data);
  if (entries.length === 0) return null;
  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
      {entries.map(([key, value]) => (
        <div key={key} className="min-w-0">
          <dt className="text-xs text-muted">{LINKED_LABELS[key] ?? key}</dt>
          <dd className="tabular truncate text-sm font-semibold text-ink">
            {renderValue(value)}
          </dd>
        </div>
      ))}
    </dl>
  );
}
